'use client';

import React, { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

export default function CTASection() {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef?.current) observer?.observe(sectionRef?.current);
    return () => observer?.disconnect();
  }, []);

  return (
    <section className="section-padding bg-gradient-primary" ref={sectionRef}>
      <div className="container mx-auto container-padding">
        <div className="text-center max-w-3xl mx-auto">
          <h2
            className="text-section lg:text-section-lg font-heading font-bold text-white mb-6"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.5s ease 0s, transform 0.5s ease 0s',
            }}
          >
            Ready to Transform Your Construction Projects?
          </h2>
          <p
            className="text-lg text-white/80 mb-8"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.5s ease 0.1s, transform 0.5s ease 0.1s',
            }}
          >
            Join the future of construction. Partner with{' '}
            <span className="font-bold text-white">NeXSYS</span> and unlock new possibilities in
            speed, sustainability, and architectural freedom.
          </p>
          <div
            className="flex flex-col sm:flex-row gap-4 justify-center"
            style={{
              opacity: visible ? 1 : 0,
              transform: visible ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.5s ease 0.2s, transform 0.5s ease 0.2s',
            }}
          >
            <Link
              href="/partners/channel"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-white text-[hsl(207,52%,37%)] hover:bg-white/90 shadow-lg hover:shadow-xl hover:-translate-y-1 font-bold h-12 rounded-lg px-8 text-base transition-all duration-300"
            >
              Become a Partner
            </Link>
            <Link
              href="/about"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap border-2 border-white bg-transparent text-white hover:bg-white/10 font-bold h-12 rounded-lg px-8 text-base transition-all duration-300"
            >
              Learn About Us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
